import { useMutation } from '@tanstack/react-query';
import { apiClient } from './client';

function triggerDownload(data: Blob, filename: string) {
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** Download estimate PDF as file */
export function useDownloadEstimatePdf() {
  return useMutation({
    mutationFn: async (projectId: string) => {
      const { data } = await apiClient.get(
        `/pdf/project/${projectId}/estimate`,
        { responseType: 'blob' },
      );
      triggerDownload(data as Blob, `estimate-${projectId.slice(0, 8)}.pdf`);
    },
  });
}

/** Download cut list PDF as file */
export function useDownloadCutListPdf() {
  return useMutation({
    mutationFn: async (projectId: string) => {
      const { data } = await apiClient.get(
        `/pdf/project/${projectId}/cut-list`,
        { responseType: 'blob' },
      );
      triggerDownload(data as Blob, `cut-list-${projectId.slice(0, 8)}.pdf`);
    },
  });
}

/** Get estimate PDF as base64 for preview */
export function usePreviewEstimatePdf() {
  return useMutation({
    mutationFn: async (projectId: string) => {
      const { data } = await apiClient.get<{ base64: string }>(
        `/pdf/project/${projectId}/estimate/preview`,
      );
      return data.base64;
    },
  });
}

/** Get cut list PDF as base64 for preview */
export function usePreviewCutListPdf() {
  return useMutation({
    mutationFn: async (projectId: string) => {
      const { data } = await apiClient.get<{ base64: string }>(
        `/pdf/project/${projectId}/cut-list/preview`,
      );
      return data.base64;
    },
  });
}
